module.exports = __webpack_public_path__ + "static/media/hackMovie.9c384ee7.wav";